import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { AuthService } from 'src/auth/auth.service';
import { DateRange } from 'src/models/DateRange.interface';
import { Provider, Providers } from 'src/models/Provider.interface';
import { ProviderBill } from 'src/models/ProviderBill.interface';
import Swal from 'sweetalert2';
import { PaginatorService } from 'src/home/paginator.service';
import { ProvidersService } from '../services/providers.service';

@Component({
  selector: 'app-provider-bill-by-date',
  templateUrl: './provider-bill-by-date.component.html',
  styleUrls: ['./provider-bill-by-date.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }],

})
export class ProviderBillByDateComponent {
  providers: Provider[] = [];
  totalElements = 0;
  displayedProviders: Provider[] = [];
  pageSizeOptions: number[] = [10, 20, 50];
  totalProviders: number = 0;
  pageSize = 10;
  pageIndex = 0;

  providerId: number = 0;
  dateRange: DateRange = { startDate: new Date(), endDate: new Date() };
  providerData: ProviderBill[] = [];
  displayedColumns: string[] = ['name', 'amount'];
  public selectedProvider: string = '';
  public isLoading: boolean = false;
  public userRole: string = '';
  availableProviders: string[] = [];
  public selectedProviderId: number | undefined;

  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
    private providersService: ProvidersService,

  ) { }

  ngOnInit(): void {
    this.handleLoadProviders(1);
    this.userRole = this.authService.getCurrentUserRole();

    this.providersService.rolEmitter.subscribe((action) => {
      if (action === 'refresh') {
        this.handleLoadProviders(1);
      }
    });
  }
  handleGetProviderBillsByDates(): void {
    if (!this.selectedProviderId) {
      Swal.fire({
        title: 'Selección requerida',
        text: 'Por favor, selecciona un proveedor antes de proceder.',
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Entendido',
      });
      return;
    }

    // Encontrar el objeto del proveedor usando selectedProviderId
    const selectedProviderObj = this.providers.find(
      (provider) => provider.id === this.selectedProviderId
    );
    if (!selectedProviderObj) {
      Swal.fire({
        title: 'Proveedor no encontrado',
        text: 'El proveedor seleccionado no existe o no está activo. Por favor, selecciona otro proveedor.',
        icon: 'error',
        confirmButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
      });
      return;
    }

    if (!this.dateRange.startDate || !this.dateRange.endDate) {
      Swal.fire({
        title: 'Fechas requeridas',
        text: 'Por favor, selecciona tanto la fecha de inicio como la de fin.',
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Entendido',
      });
      return;
    }

    this.isLoading = true;
    this.providersService
      .getProviderBillsByDateRange(selectedProviderObj.id, this.dateRange, 1)
      .subscribe(
        (response: any) => {
          this.isLoading = false;
          if (response.results.length > 0) {
            this.providerData = response.results;
          } else {
            Swal.fire({
              title: 'Sin datos',
              text: 'No se encontraron datos para el proveedor en las fechas seleccionadas.',
              icon: 'info',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Aceptar',
            });
            this.providerData = [];
          }
        },
        (error) => {
          this.isLoading = false;
          console.error('Error al obtener las facturas:', error);
          Swal.fire({
            title: 'Error',
            text: 'Hubo un problema al obtener los datos. Por favor, inténtalo de nuevo.',
            icon: 'error',
            confirmButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
          });
        }
      );
  }

  handleLoadProviders(page: number): void {
    this.isLoading = true;
    this.providersService.getListProviders(page).subscribe(
      (data) => {
        this.isLoading = false;
        this.providers = data.results.filter(
          (provider) => provider.status === 'active'
        );
        this.availableProviders = this.providers.map(
          (provider) => provider.name
        );
        this.updateDisplayedProviders();

      },
      (error) => {
        this.isLoading = false;
        console.error('Error loading providers:', error);
      }
    );
  }

  handlePageEvent(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updateDisplayedProviders();
  }

  updateDisplayedProviders(): void {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.displayedProviders = this.providers.slice(startIndex, endIndex);
  }

}
